import CurrencyValueUIModel from './currency-value';
import FareTotalUIModel from './fare-total';

/**
 * An estimate of a fare price. In practice, the price for one adult.
 * It's almost like the LegFareUIModel, but it doesn't break the price by passenger type
 * neither exposes tax details.
 *
 * This model is returned by Detailed Fares requests and can be added to a shopping
 * cart. When a shopping cart is saved, the API converts this model in full prices
 * (LegFareUIModel instances).
 */
class LegFareEstimateUIModel {
  /**
    * @param  {string} options._lanceJSON     [description]
    * @param  {number} options.currencyTotal  [description]
    * @param  {string} options.currencyCode   [description]
    * @param  {boolean} options.discounted     [description]
    * @param  {string} options.fareType       [description]
    * @param  {integer} options.seatsRemaining [description]
    * @param  {object} options.taxDetails     [description]
  */
  constructor({
    _lanceJSON,
    couponCode,
    currency,
    currencyTotal,
    currencyCode,
    discounted,
    estimate,
    fareId,
    fareType,
    premierPartiallyUnavailable,
    saleStatus,
    seatsRemaining,
    segmentCodes,
  } = {}) {
    this._lanceJSON = _lanceJSON;
    this.couponCode = couponCode;
    this.currency = new CurrencyValueUIModel(currency);
    this.currencyCode = currencyCode;
    this.currencyTotal = currencyTotal;
    this.estimate = new FareTotalUIModel(estimate);
    this.fareId = fareId;
    this.fareType = !fareType ? '' : fareType;
    this.hasDiscountAvailable = discounted ? discounted : false;
    this.hasSeatsAvailable = seatsRemaining > 0;
    this.isCoachClass = fareType.indexOf('COACH') > -1;
    this.isFirstClass = fareType.indexOf('FIRST') > -1;
    this.isFlexible = fareType.indexOf('FL') > -1;
    this.isPromo = fareType.indexOf('EC') > -1;
    this.premierPartiallyUnavailable = premierPartiallyUnavailable;
    this.hasSaleStatus = saleStatus ? saleStatus : false;
    this.seatsRemaining = seatsRemaining;
    this.segmentCodes = segmentCodes ? segmentCodes._data : null;
  }
}

export default LegFareEstimateUIModel;
